export const iconFontAwesomeCommunicationPhoneVolume = (
	<i className="fa-solid fa-phone-volume"></i>
);
